import {IGvfResponse} from "./GvfClient";

export class SpecificationFilter {
    private readonly defaultPrNumberOrigins: string[] = ['E', 'G', 'P'];

    constructor(private readonly allowedPrNumberOrigins: string[] | undefined) {
        if (this.allowedPrNumberOrigins === undefined) {
            this.allowedPrNumberOrigins = this.defaultPrNumberOrigins;
        }
    }

    public filter(gvfDetailsResponse: IGvfResponse | undefined): string[] | undefined {
        if (gvfDetailsResponse === undefined || gvfDetailsResponse.specifications === undefined) {
            return undefined;
        }

        const filteredSpecifications = gvfDetailsResponse.specifications
            .filter(specification => this.allowedPrNumberOrigins!.includes(specification.origin))
            .map(specification => specification.codeText);

        if (filteredSpecifications.length > 0) {
            return filteredSpecifications;
        } else {
            return gvfDetailsResponse.specifications.map(specification => specification.codeText);
        }
    }
}
